import { Editor, Element, Node } from 'slate';

// Is node an element
export const isElement = (node: Node): node is Element =>
	!Editor.isEditor(node) && Element.isElement(node);

// Is node an element of the given type
export const isElementType = (node: Node, type: Element['type']) =>
	isElement(node) && node.type === type;
